import { toast } from "sonner";
import { CUSTOMER_GROUPS } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn } from "./ui";

export default function CustomerGroups() {
  return (
    <div data-testid="admin-customer-groups">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauna klientu grupa (DEMO)")} data-testid="group-add">+ Pievienot grupu</Btn>}>
        Klientu grupas ({CUSTOMER_GROUPS.length})
      </PageTitle>
      <Table head={["Grupa", "Atlaide no bāzes cenas", "Cenu attēlojums", "Dalībnieki", ""]}>
        {CUSTOMER_GROUPS.map((g) => (
          <tr key={g.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`group-row-${g.id}`}>
            <td className="p-3 font-bold">{g.name}</td>
            <td>{g.discount > 0 ? <Badge color="red">–{g.discount}%</Badge> : <Badge color="gray">Bāzes cena</Badge>}</td>
            <td className="text-[#6B6B6B]">{g.priceDisplay}</td>
            <td>{g.members} klienti</td>
            <td className="p-3"><Btn variant="outline" onClick={() => toast.success("Grupas iestatījumi atvērti (DEMO)")} data-testid={`group-edit-${g.id}`}>Rediģēt</Btn></td>
          </tr>
        ))}
      </Table>
      <p className="text-xs text-[#6B6B6B] mt-3">Grupu atlaides automātiski piemērojas visam katalogam. Individuālas līguma cenas var iestatīt produkta kartītē (DEMO).</p>
    </div>
  );
}
